// http://stackoverflow.com/a/290129
export function formatNumber(number: number | string): string {
    if (typeof number === 'number') {
        number = String(number);
    }
    return number.replace(/\B(?=(\d{3})+(?!\d))/g, '$&\u00A0');
}
